import React, {  Component } from 'react';
import { browserHistory } from 'react-router';
import { connect } from 'react-redux';

/* Actions */
import {
	resetBrochurePayload,
	selectBrochureCreateOption
} from '../../redux/actions';

class AddToBrochureOverlayDialog extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showDialog: true,
			whereToAddProducts: 'new',
			selectedSavedBrochureId: '',
			selectedSavedBrochureIdError: ''
        }
    }
    closeDialog(event) {
        event.preventDefault();
        this.setState({
            showDialog: false
        });
		this.props.handleDialog && this.props.handleDialog('AddToBrochureOverlayDialog', false);
    }
	componentDidMount() {
		// window.scrollTo(0, 0);
		this.setState({
            showDialog: this.props.showDialog
        });
	}
	handleContinue(event) {
		event.preventDefault();
		const self = this;
		self.props.handleDialog('AddToBrochureOverlayDialog', false);
		if(self.state.whereToAddProducts === "new") {
			//Reset Brochure payload before creating a new brochure
			self.props.resetBrochurePayload(self.props.getSelectedAccountNumber());
			self.props.selectBrochureCreateOption(2);
			browserHistory.push("/create-brochure-step1");
		} else {
			if(self.state.selectedSavedBrochureId === "") {
				self.setState({
					selectedSavedBrochureIdError: "error"
				});
			} else {
				//Update store with already available data of saved brochure so that step1 will have some prepopulated values
				//Need to update brochure -> payload -> brochure object with selected saved brochure to proceed.
				//this.props.dispatch(loadSelectedSavedBrochure(this.state.selectedSavedBrochureId));
				browserHistory.push("/create-brochure-step1");
			}
		}
	}
	handleWhereToAddProducts(whereToAdd, event) {
		this.setState({
			whereToAddProducts: event.target.value,
			selectedSavedBrochureIdError: ""
		});
	}
	handleChangeExistingBrochure(event) {
		this.setState({
			whereToAddProducts: "existing",
			selectedSavedBrochureId: event.target.value,
			selectedSavedBrochureIdError: ""
		});
	}
    render() {
        return (
            <div className={"overlayDialog "+(this.state.showDialog?"visible":"hide")} id="addToBrochureOverlayDialog">
                <div className="blackoutLayer"></div>
                <div className="overlayDialogWindow">
                    <a className="closeButton" onClick={this.closeDialog.bind(this)}>×</a>
                    <h2 className="title">Add Products</h2>
					<form className="addProductsToBrochureForm" id="addProductsToBrochureForm" name="addProductsToBrochureForm" action="">
						<table className="formTableTypeA">
							<tbody>
								<tr>
									<td>
										<input type="radio" name="addToBrochure" id="addToBrochure_createNewBrochure" onClick={this.handleWhereToAddProducts.bind(this, "new")} onChange={()=>{}} checked={this.state.whereToAddProducts === "new"?true:false} defaultValue="new"/>
									</td>
									<td>
										<label htmlFor="addToBrochure_createNewBrochure"><strong>Create a new brochure</strong></label>
									</td>
								</tr>
								{this.props.state.brochure.savedBrochures && this.props.state.brochure.savedBrochures.responseObject
									?<tr>
										<td>
											<input type="radio" name="addToBrochure" id="addToBrochure_addToExistingBrochure" onClick={this.handleWhereToAddProducts.bind(this, "existing")} onChange={()=>{}} checked={this.state.whereToAddProducts === "existing"?true:false} defaultValue="existing" />
										</td>
										<td>
											<label htmlFor="addToBrochure_addToExistingBrochure"><strong>Add to existing brochure</strong></label>
											<br />
											<select name="existingBrochure" disabled={this.state.whereToAddProducts === 'existing'?false:true} onChange={this.handleChangeExistingBrochure.bind(this)} className={this.state.selectedSavedBrochureIdError}>
												<option value="">Select brochure</option>
												{this.props.state.brochure.savedBrochures.responseObject.map((item, index) => {
													return <option key={index} value={item.brochureId}>{item.brochureName}</option>
												})}
											</select>
										</td>
									</tr>
									:null
								}
							</tbody>
						</table>
						<div className="noButtonContainer">
							<a className="noButton blueButton" onClick={this.closeDialog.bind(this)} href="">Cancel</a>
						</div>
						<div className="yesButtonContainer">
							<input type="submit" className="yesButton blueButton" onClick={this.handleContinue.bind(this)} value="Continue" />
						</div>
					</form>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
	return {state};
};

const mapDispatchToProps = (dispatch) => ({
	resetBrochurePayload: (accountNumber) => dispatch(resetBrochurePayload(accountNumber)),
	selectBrochureCreateOption: (data) => dispatch(selectBrochureCreateOption(data)),
});

AddToBrochureOverlayDialog = connect(mapStateToProps, mapDispatchToProps)(AddToBrochureOverlayDialog);
export default AddToBrochureOverlayDialog;



// WEBPACK FOOTER //
// ./src/App/components/dialogs/addToBrochureOverlayDialog.js